import { useQuery } from '@tanstack/react-query'
import { getThumbnailCapture } from '../../service/list'

function useGetThumbnail() {
  return useQuery({
    queryKey: ['get-thumbnails'],
    queryFn: () => getThumbnailCapture(),
    staleTime: 6 * 1000,
  })
}

export default useGetThumbnail
